import { FC } from 'react';

// Third-party
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { useTranslation } from 'react-i18next';
import { BaseTooltip } from '@mgm/common/components/base';
import { TTableActions } from './type';

// Hooks
import { useAppDispatch } from '../../../../hooks/useAppStore';

// Redux-toolkit
import { sheetsActions } from '../../../../store/sheets/slice';

// Assets
import { ReactComponent as ViewIcon } from '../../../../static/icons/ic_view.svg';

const TableActions: FC<TTableActions> = ({ chosenMember }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation('timesheets');

  const openTimesheetsCard = () => {
    dispatch(sheetsActions.setSelectedMember(chosenMember));
    navigate(`:${chosenMember.personnel?.name}`);
  };

  return (
    <Grid display="flex" container spacing={2}>
      <Grid>
        <BaseTooltip tooltipText={t('viewDetailedShiftsData')}>
          <Box id="view-timesheets" className="cursor-pointer" onClick={openTimesheetsCard}>
            <SvgIcon component={ViewIcon} inheritViewBox />
          </Box>
        </BaseTooltip>
      </Grid>
    </Grid>
  );
};

export {
  TableActions,
};
